import { Cross } from '@transferwise/icons';
import { clsx } from 'clsx';
import { useIntl } from 'react-intl';
import messages from '../../../dateLookup/dateTrigger/DateTrigger.messages.mjs';
import { jsx } from 'react/jsx-runtime';

function SelectInputClearButton({
  className,
  onClick
}) {
  const intl = useIntl();
  return /*#__PURE__*/jsx("button", {
    type: "button",
    "aria-label": intl.formatMessage(messages.ariaLabel),
    className: clsx(className, 'np-select-input-addon np-select-input-addon--interactive'),
    onClick: onClick,
    children: /*#__PURE__*/jsx(Cross, {
      size: 16
    })
  });
}

export { SelectInputClearButton };
//# sourceMappingURL=SelectInputClearButton.mjs.map
